import React, { useMemo } from 'react';
import OptimizedChart from '../utils/OptimizedChart';
import { useApexTheme } from '../utils/apexTheme';

const EquityCurveChart = ({ equitySeries, height = 300 }) => {
  const { colors } = useApexTheme();

  const { componentOptions, series } = useMemo(() => {
    if (!equitySeries || equitySeries.length === 0) return { componentOptions: null, series: [] };

    const data = equitySeries.map(item => ({
      x: new Date(item.timestamp).getTime(),
      y: item.equity
    }));

    const options = {
      chart: {
        type: 'area',
        height,
        toolbar: {
          show: true,
          tools: {
            download: true,
            selection: true,
            zoom: true,
            zoomin: true,
            zoomout: true,
            pan: true,
            reset: true
          }
        },
        zoom: {
          enabled: true
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: 'smooth',
        width: 2
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.05,
          stops: [0, 100]
        }
      },
      colors: [colors.primary || '#2196f3'],
      xaxis: {
        type: 'datetime',
        labels: {
          datetimeFormatter: {
            year: 'yyyy',
            month: "MMM 'yy",
            day: 'dd MMM',
            hour: 'HH:mm'
          }
        }
      },
      yaxis: {
        title: {
          text: 'Portfolio Value (₹)'
        },
        labels: {
          formatter: (value) => '₹' + value.toLocaleString('en-IN')
        }
      },
      tooltip: {
        x: {
          format: 'dd MMM yyyy'
        },
        y: {
          formatter: (value) => '₹' + value.toLocaleString('en-IN', { maximumFractionDigits: 2 })
        }
      }
    };

    return {
      componentOptions: options,
      series: [{
        name: 'Portfolio Value',
        data: data
      }]
    };
  }, [equitySeries, height, colors]);

  if (!componentOptions) {
    return (
      <div className="flex items-center justify-center text-base-content/60" style={{ height }}>
        No equity data available
      </div>
    );
  }

  return (
    <div>
      <h4 className="text-sm font-bold mb-2">Equity Curve</h4>
      <OptimizedChart
        componentOptions={componentOptions}
        series={series}
        type="area"
        height={height}
        chartName="EquityCurve"
      />
    </div>
  );
};

export default EquityCurveChart;
